export default "__VITE_ASSET__DeVT_WeL__"